import { TiThMenu } from "react-icons/ti";
import { MdClose } from "react-icons/md";

export default function MobileNav({ isOpen, setIsOpen }) {
    return (
        <div className='md:hidden flex justify-between items-center p-4 bg-white shadow-sm fixed top-0 left-0 right-0 z-50'>
            <button onClick={() => setIsOpen(!isOpen)} className='p-2 rounded-md hover:bg-gray-100 transition-colors' aria-label="Toggle Menu">
                {isOpen ? <MdClose size={24} className='text-docpgrPurple'/> : <TiThMenu size={24} className='text-docpgrPurple' />}
            </button>
        </div>
    )
}